import {
  Box,
  Container,
  Flex,
  Heading,
  Text,
  Wrap,
  WrapItem,
  useColorMode,
} from '@chakra-ui/react'
import { motion } from 'framer-motion'

const MotionBox = motion.create(Box)

const fadeInUp = {
  hidden: { opacity: 0, y: 12 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.4, ease: 'easeOut' as const } },
}

const integrations = [
  'Claude MCP',
  'Cursor',
  'ChatGPT',
  'REST API',
  'Raw Access',
]

export function IntegrationsSection() {
  const { colorMode } = useColorMode()
  const isDark = colorMode === 'dark'

  return (
    <Box
      id="integrations"
      scrollMarginTop="72px"
      py={{ base: 16, md: 24 }}
      bg={isDark ? 'stone.900' : 'stone.50'}
    >
      <Container maxW="960px">
        <MotionBox
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-50px' }}
          variants={fadeInUp}
          textAlign="center"
        >
          <Heading
            as="h2"
            fontFamily="heading"
            fontWeight={700}
            fontSize={{ base: '2rem', md: 'clamp(2rem, 4.5vw, 2.75rem)' }}
            letterSpacing="-0.025em"
            lineHeight={1.15}
            color={isDark ? 'stone.50' : 'stone.900'}
            mb={4}
          >
            Connects to your AI workflow.
          </Heading>

          <Text
            fontSize="1.125rem"
            color="stone.400"
            lineHeight={1.8}
            maxW="560px"
            mx="auto"
            mb={10}
          >
            MCP protocol lets AI assistants create and read shares directly. REST API for automation. Raw access for when your tools need the content back. Paste for everything else.
          </Text>

          {/* Integration chips */}
          <Flex justify="center">
            <Wrap spacing={3} justify="center">
              {integrations.map((name) => (
                <WrapItem key={name}>
                  <Box
                    px={5}
                    py={2}
                    bg={isDark ? 'stone.800' : 'stone.100'}
                    borderRadius="8px"
                    fontFamily="heading"
                    fontWeight={500}
                    fontSize="15px"
                    letterSpacing="-0.01em"
                    color={isDark ? 'stone.300' : 'stone.600'}
                  >
                    {name}
                  </Box>
                </WrapItem>
              ))}
            </Wrap>
          </Flex>

        </MotionBox>
      </Container>
    </Box>
  )
}
